module.exports = __webpack_public_path__ + "img/Battery2.908dc74d.svg";